import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route } from 'react-router';
import { Helmet } from 'react-helmet';

import { entityReset } from '@uncinc/react-drupal-core';

import { DEFAULT_LANGUAGE } from '../../config/constants';

const CustomRoute = (props) => {
  const language = useSelector((state) => state.getIn(['ui', 'language']), DEFAULT_LANGUAGE);
  const dispatch = useDispatch();

  // We may have done a request to translate-path for the current route.
  // Reset the entity to prevent a possible 404 page flash.
  useEffect(() => () => {
    dispatch(entityReset());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Helmet>
        <html lang={language} />
      </Helmet>
      <Route {...props} />
    </>
  );
};

export default CustomRoute;
